module.exports = __webpack_public_path__ + "img/nota-folio.1f4370ec.png";